import { render, staticRenderFns } from "./coursesBycategory.html?vue&type=template&id=25858000&scoped=true&"
import script from "./coursesBycategory.js?vue&type=script&lang=js&"
export * from "./coursesBycategory.js?vue&type=script&lang=js&"
import style0 from "./coursesBycategory.css?vue&type=style&index=0&id=25858000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25858000",
  null
  
)

export default component.exports